import { StyledSwitch } from "../styles";

const Switch = ({ id, name, value, onChange, ...props }) => {
  const handleChange = (checked) => {
    onChange && onChange({ target: { name, checked } });
  };

  return (
    <>
      <StyledSwitch id={id} name={name} value={value} onChange={handleChange} {...props} />
    </>
  );
};

export default Switch;
